import { ReactNode, useMemo } from "react";
import Link from "next/link";
import styles from './schemes.module.css';
import global from '../bid.module.css';
import buttons from "components/_styled/buttons.module.css";
import { ResultThumbnail } from "lib/types";
import LazyImage from "components/LazyImage";
import interpretThumbnail from "lib/interpretThumbnail";


const getThumbnail = (images: [{format: object}], name: string) => {
  const thumb: ResultThumbnail = {
    origin: '',
    default:"fallback-images/scheme-sc-fullback.jpeg",
    sizes: [200, 400, 600, 800],
  };

  // get the real one
  if (images && images.length) {
    thumb.origin = "this";
    Object.keys(images[0].format)
      .map((k) => ({...images[0].format[k], file_type: k.endsWith('wp') ? 'webp' : 'jpg' }))
      .forEach((med) => {
        if (thumb.sizes.includes(med.width)) {
          if (med.file_type in thumb) thumb[med.file_type][med.width] = med.uri;
          else
            thumb[med.file_type] = {
              [med.width]: med.uri,
            };
        }
      });

    if ("jpg" in thumb) {
      thumb.default = thumb.jpg?.[200];
    } else if ("png" in thumb) thumb.default = thumb.png?.[200];
  }

  return interpretThumbnail(thumb, name, '400');
};

type PropsResultComponent = {
  uri: string,
  name: string,
  images: [{format: object}],
  id:  {
    raw: string
  }
}

const ResultComponent = ({ uri, name, images, id }: PropsResultComponent) => {
  const thumbnailProps = useMemo(() => {
    return getThumbnail(images, name);
  }, [images, name]);
  return (
    <li className={styles.result} key={`scheme-${id.raw}`}>
      <Link href={`/scheme/${uri}-${id.raw}`} prefetch={false} passHref legacyBehavior>
        <a target="_blank">
          <div>
            <LazyImage {...thumbnailProps} />
          </div>
          <h4>{name}</h4>
          <button className={buttons.SecondaryButton}>View Scheme</button>
        </a>
      </Link>
    </li>
  );
};

type Props = {
  title: ReactNode,
  selectedSchemes: PropsResultComponent[],
}

const Schemes = ({ title, selectedSchemes }: Props) => {
  return (
    <section className={styles.Background} id="shopping_centres" >
      <div className={`${global.Container} ${styles.Container}`}>
        <h3>{title}</h3>

        <ul className={styles.Results}>
          {selectedSchemes.map((scheme) => (
            <ResultComponent key={scheme.id.raw} {...scheme}  />
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Schemes;
